// Card组件的定义（Card.tsx）

import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import "./index.less"; // 引入Card组件的CSS样式
import { goToPage } from "@/utils/tools";
import { goToNativePage, goToPageV2 } from "@/utils/common";
import copyImage from "@/assets/copy@1x.png";
import { Toast } from "@xp-design/mobile";
import { processOssImage } from "@/utils/image";

interface CardProps {
  exchangeItemName: string;
  conversionCodeStatusName: string;
  conversionCodeCode: string;
  verificationCompletionTime?: string;
  remark?: string;
  exchangeProductCode: string;
  exchangeItemId: string;
  exchangeProductSmallCode?: string;
  // 可根据需要添加更多属性
}

const Card: React.FC<CardProps> = ({
  exchangeItemName,
  conversionCodeStatusName,
  conversionCodeCode,
  verificationCompletionTime,
  remark,
  exchangeProductCode, //中类
  exchangeItemId,
  exchangeProductSmallCode, //小类
}) => {
  // const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    // setCopied(true);
    // setTimeout(() => {
    //   setCopied(false);
    // }, 2000); // 2秒后重置复制状态
    Toast.show({
      content: "已复制到剪贴板",
    });
  };
  const transformValue = (exchangeProductSmallCode: string | undefined) => {
    switch (exchangeProductSmallCode) {
      // 电量卡
      case "06":
        return "3";
        break;
      // 次数卡
      case "04":
        return "1";
        break;
      // 整单折扣卡
      case "05":
        return "5";
        break;
      // 储值卡
      case "07":
        return "07";
        break;
      // 服务费折扣卡
      case "08":
        return "6";
        break;
      default:
        return "-1";
    }
  };
  return (
    <div className="card">
      <div className="flex-column">
        <div className="flex flex-between flex-center h44 pb16">
          <div className="c-title ">{exchangeItemName}</div>
          <div className="c-status ">{conversionCodeStatusName}</div>
        </div>

        <div className="c-code flex flex-center  pb12">
          兑换码：{conversionCodeCode}
          <CopyToClipboard text={conversionCodeCode} onCopy={handleCopy}>
            <span className={`copy-icon`}>
              <img src={processOssImage(copyImage)} className="back-image" alt="复制" />
            </span>
          </CopyToClipboard>
        </div>

        {remark ? (
          <>
            <div className="c-time h44 pb12">
              兑换时间：{verificationCompletionTime}
            </div>

            <div className="flex flex-between flex-center h44">
              <div className="c-remark ">兑换备注：{remark}</div>
              <div
                className="c-detail "
                onClick={() => {
                  if (conversionCodeStatusName.includes("发放中")) {
                    Toast.show({
                      content: "权益发放中，请耐心等待",
                    });
                    return;
                  }
                  const { origin } = window.location;
                  console.log(
                    "exchangeProductCode中类",
                    exchangeProductCode,
                    "exchangeProductSmallCode小类",
                    exchangeProductSmallCode,
                  );
                  if (exchangeProductCode == "6") {
                    //券包
                    goToNativePage({
                      mini: "/charging/pages/voucher-list/index?tabIndex=1",
                      app: "xiaopeng://charging/card?type=1",
                      browser: `https://app.xiaopeng.com/activity/openurl?url=${encodeURIComponent("xiaopeng://charging/card?type=1")}`,
                    });
                    // 充电券
                  } else if (exchangeProductCode == "1") {
                    goToPageV2({
                      url: `${origin}/apps/charge-web/coupon-detail.html?couponId=${exchangeItemId}`,
                    });
                  } else if (
                    //电卡
                    exchangeProductCode == "11" ||
                    exchangeProductCode == "5"
                  ) {
                    if (exchangeProductSmallCode == "07") {
                      //储值卡
                      goToNativePage({
                        mini: `/charging/pages/card-detail/index?cardId=${exchangeItemId}&isStore=true`,
                        app: "xiaopeng://charging/card?type=2",
                        browser: `https://app.xiaopeng.com/activity/openurl?url=${encodeURIComponent("xiaopeng://charging/card?type=2")}`,
                      });
                    } else {
                      goToNativePage({
                        mini: `/charging/pages/card-detail/index?cardId=${exchangeItemId}&cardTypeId=${transformValue(exchangeProductSmallCode)}`,
                        app: "xiaopeng://charging/card?type=0",
                        browser: `https://app.xiaopeng.com/activity/openurl?url=${encodeURIComponent("xiaopeng://charging/card?type=0")}`,
                      });
                    }
                  } else if (exchangeProductCode == "7") {
                    goToPageV2({
                      url: `${origin}/apps/charge-web/charge-vip.html`,
                    });
                  }
                }}
              >
                查看详情
              </div>
            </div>
          </>
        ) : (
          <div className="flex flex-between flex-center h44">
            <div className="c-time ">
              兑换时间：{verificationCompletionTime}
            </div>
            <div
              className="c-detail "
              onClick={() => {
                if (conversionCodeStatusName.includes("发放中")) {
                  Toast.show({
                    content: "权益发放中，请耐心等待",
                  });
                  return;
                }
                const { origin } = window.location;
                console.log(
                  "exchangeProductCode中类",
                  exchangeProductCode,
                  "exchangeProductSmallCode小类",
                  exchangeProductSmallCode,
                );
                if (exchangeProductCode == "6") {
                  //券包
                  console.log(
                    "跳转路径：/charging/pages/voucher-list/index?tabIndex=1",
                  );
                  goToNativePage({
                    mini: "/charging/pages/voucher-list/index?tabIndex=1",
                    app: "xiaopeng://charging/card?type=1",
                    browser: `https://app.xiaopeng.com/activity/openurl?url=${encodeURIComponent("xiaopeng://charging/card?type=1")}`,
                  });
                  // 充电券
                } else if (exchangeProductCode == "1") {
                  goToPageV2({
                    url: `${origin}/apps/charge-web/coupon-detail.html?couponId=${exchangeItemId}`,
                  });
                } else if (
                  //电卡
                  exchangeProductCode == "11" ||
                  exchangeProductCode == "5"
                ) {
                  if (exchangeProductSmallCode == "07") {
                    //储值卡
                    goToNativePage({
                      mini: `/charging/pages/card-detail/index?cardId=${exchangeItemId}&isStore=true`,
                      app: "xiaopeng://charging/card?type=2",
                      browser: `https://app.xiaopeng.com/activity/openurl?url=${encodeURIComponent("xiaopeng://charging/card?type=2")}`,
                    });
                  } else {
                    goToNativePage({
                      mini: `/charging/pages/card-detail/index?cardId=${exchangeItemId}&cardTypeId=${transformValue(exchangeProductSmallCode)}`,
                      app: "xiaopeng://charging/card?type=0",
                      browser: `https://app.xiaopeng.com/activity/openurl?url=${encodeURIComponent("xiaopeng://charging/card?type=0")}`,
                    });
                  }
                } else if (exchangeProductCode == "7") {
                  goToPageV2({
                    url: `${origin}/apps/charge-web/charge-vip.html`,
                  });
                }
              }}
            >
              查看详情
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Card;
